module.exports = __webpack_public_path__ + "img/square_example.2c8639c3.png";